import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Select, Row, Upload, Radio, Tooltip } from 'antd'
import { FormItem } from '../../../../styles/shared.style'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'

const RewardConditionForm = (props) => {
  const { visible, onOk, onCancel, formData, form, } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        detail: formData.detail,
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])


  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          detail: values.detail
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a Reward Condition`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="รายละเอียด">
          {getFieldDecorator(`detail`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input.TextArea rows={8}
            name="detail"
            placeholder="รายละเอียด" />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedRewardConditionForm = Form.create({ name: 'RewardConditionForm' })(
  RewardConditionForm
)
export default WrappedRewardConditionForm
